/* global __VERSION__ */
import PropTypes from "prop-types";
import React from "react";
import { NavLink } from "react-router-dom/es";
import Dropdown, {
  DropdownContent,
  DropdownTrigger,
} from "react-simple-dropdown";
import "react-simple-dropdown/styles/Dropdown.css";
import { Box } from "signoxe/components/layout";
import {
  Icon,
  NotificationsDropdown,
  CustomIcon,
} from "signoxe/components/widgets";
import "./styles.scss";
import { connect } from "react-redux";
import { getProfile } from "../../../selectors";

import deviceIcon from "signoxe/images/menu_icons/Device.png";
import channelIcon from "signoxe/images/menu_icons/Channel.png";
import homeIcon from "signoxe/images/menu_icons/Home.png";
import assetIcon from "signoxe/images/menu_icons/Assets.png";
import tickerIcon from "signoxe/images/menu_icons/Tickers.png";
import playlistIcon from "signoxe/images/menu_icons/Playlist.png";
import reportsIcon from "signoxe/images/menu_icons/report-icon.png";

class MainMenu extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {

    const {
      username,
      profile,
      notifications,
      unreadNotificationCount,
      fetching,
      onClickLogout,
      onClickRefresh,
      onClickUploads,
      onClickHelp,
      onMarkAllNotificationsRead,
      reportNavActive,
    } = this.props;

    const offlineOnly = localStorage.getItem('offlineOnly')
    const self_activation = localStorage.getItem('self_activation')
    const features = profile && profile.features
    const pingWindowEnabled = features && profile.features.ping_window
    const reportWindowEnabled = features && profile.features && profile.features.device_reporting
    const showHomeIcon = reportWindowEnabled || pingWindowEnabled

    return (
      <Box
        direction="row"
        alignItems="baseline"
        className="main-menu wrap-for-small"
      >
        <Box
          tag="nav"
          direction="row"
          alignItems="baseline"
          className="pages main-nav"
        >

          {showHomeIcon && (
         <NavLink to="/report" className={reportNavActive ? 'active' : ''}>
            <CustomIcon title="report" path={reportsIcon} />
              <span className="pages-icon">Reports</span>
            </NavLink>
          )}
         
          <NavLink to="/device-groups" activeClassName="active">
            <CustomIcon title="Devices" path={deviceIcon} />
            <span className="pages-icon">Devices</span>
          </NavLink>
          <>
          {profile &&
            profile.features &&
            profile.features.multiregion &&
            profile.multiregion_switch === true ? (
            <NavLink to="/channels" activeClassName="active">
              <CustomIcon path={channelIcon} title="Channel" />
              <span className="pages-icon">Channel</span>
            </NavLink>
          ) : null}
          <NavLink to="/assets" activeClassName="active">
            <CustomIcon path={assetIcon} title="Assets" />
            <span className="pages-icon">Assets</span>
          </NavLink>
          <NavLink to="/tickers" activeClassName="active">
            <CustomIcon path={tickerIcon} title="Tickers" />
            <span className="pages-icon">Tickers</span>
          </NavLink>
          <NavLink to="/playlists" activeClassName="active">
            <CustomIcon path={playlistIcon} title="Playlist" />
            <span className="pages-icon">Playlists</span>
          </NavLink>
          
        </>
          
        </Box>
        <Box direction="row" alignItems="baseline" className="icons">
          <NotificationsDropdown
            notifications={notifications}
            onMarkAllNotificationsRead={onMarkAllNotificationsRead}
            unreadNotificationCount={unreadNotificationCount}
          />
          <Icon
            name="upload"
            size="1.1rem"
            margin="0.5rem"
            color="white"
            onClick={onClickUploads}
            title="Uploads"
          />
          <Icon
            name="question"
            size="1.1rem"
            margin="0.5rem"
            color="white"
            onClick={onClickHelp}
            title="Help"
          />
          <Icon
            name="refresh"
            color="white"
            spin={fetching}
            className="show-for-medium"
            size="1.1rem"
            margin="0.5rem"
            onClick={onClickRefresh}
            title="Refresh"
          />
          <Dropdown>
            <DropdownTrigger>
              <Icon
                title="User menu"
                name="user-circle"
                size="1.1rem"
                margin="0.5rem"
                color="white"
              />
            </DropdownTrigger>
            <DropdownContent className="user-menu card depth-1">
              <li>User: {username}</li>
              <li>
                <NavLink to="/profile">Profile</NavLink>
              </li>
              
              <li>
                <a href="#" onClick={onClickLogout}>
                  Log Out
                </a>
              </li>
              <li className="small">{__VERSION__}</li>
            </DropdownContent>
          </Dropdown>
        </Box>
      </Box>
    );
  }
}

MainMenu.propTypes = {
  onClickLogout: PropTypes.func.isRequired,
  onClickRefresh: PropTypes.func.isRequired,
  onClickHelp: PropTypes.func.isRequired,
  onClickUploads: PropTypes.func.isRequired,
  username: PropTypes.string.isRequired,
  profile: PropTypes.object.isRequired,
  fetching: PropTypes.bool.isRequired,
  notifications: PropTypes.array.isRequired,
  unreadNotificationCount: PropTypes.number,
  onMarkAllNotificationsRead: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  offlineOnly: state.authState.offlineOnly,
})

export default connect(mapStateToProps)(MainMenu);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/MainMenu/index.js